import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useDistanceToNow } from '@/hooks';
import { ClockFillIcon, PlayFillIcon } from '@/icons';
import { type QuizListItemProps } from './QuizListItem';
export const AdditionalInfo = (props: Pick<QuizListItemProps['item'], 'playCount' | 'createdAt'>) => {
  const distanceNow = useDistanceToNow();
  return <div className={'mt-xs flex h-[18px] min-w-[120px] items-center gap-lg text-body-sm-medium text-neutral'} data-sentry-component="AdditionalInfo" data-sentry-source-file="AdditionalInfo.tsx">
      <div className={'flex items-center gap-3xs text-center'}>
        <ClockFillIcon size="xs" fill={ICON_COLOR.assistive} data-sentry-element="ClockFillIcon" data-sentry-source-file="AdditionalInfo.tsx" />
        <span className={'pt-[1px]'}>{distanceNow(props.createdAt ?? '')}</span>
      </div>
      <div className={'flex items-center gap-3xs text-center'}>
        <PlayFillIcon size="xs" fill={ICON_COLOR.assistive} data-sentry-element="PlayFillIcon" data-sentry-source-file="AdditionalInfo.tsx" />
        <span className={'pt-[1px]'}>{props.playCount}</span>
      </div>
    </div>;
};